import React, { Component, Suspense } from "react";
import ErrorPage from "./ErrorPage";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../App";
import LoadingBackdrop from "../LoadingBackdrop/LoadingBackdrop";
import BaseFooter from "../Footer/BaseFooter";

export const PageWrapper = ({ children }) => {
    return (
        <Suspense fallback={<LoadingBackdrop open={true} />}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </Suspense>
    );
};

export default class ErrorHandle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error Boundary caught an error:", error, errorInfo);
        this.setState({ hasError: true });
    }

    render() {
        const route = this.props.route;

        if (this.state.hasError) {
            return (
                <PageWrapper>
                    {/*<LogoNavbar currentPath={route.path} isPublic={route.public} />*/}
                    <ErrorPage />
                    {<BaseFooter />}
                </PageWrapper>
            );
        }
        return this.props.children;
    }
}
